import { Table } from '@mantine/core'

import { Text } from '@/components/Text/Text'

import classes from './TableTitle.module.css'

export function TableTitle() {
  return (
    <Table.Thead>
      <Table.Tr className={classes.item}>
        <Table.Th>
          <Text variant="body_1_medium_green">Goal</Text>
        </Table.Th>
        <Table.Th>
          <Text variant="body_1_medium_green">Start date</Text>
        </Table.Th>
        <Table.Th>
          <Text variant="body_1_medium_green">Due date</Text>
        </Table.Th>
        <Table.Th>
          <Text variant="body_1_medium_green">Final goal</Text>
        </Table.Th>
        <Table.Th>
          <Text variant="body_1_medium_green">Progress</Text>
        </Table.Th>
      </Table.Tr>
    </Table.Thead>
  )
}
